import api from "apis/casePhotos";
import { HTTP_POST, WebApiRequest } from "tools/webservice";
import WebConfig from "middlewares/WebConfig";
import { PhotoPropertiesPhotoSvc } from "typeConstants/photos/photos";
import { PhotoEditSaveRequest } from "components/Photos/PhotoTool";

export interface UpdateMultiplePhotosRequestBody {
  PhotoProperties: PhotoPropertiesPhotoSvc[];
}

export const savePhotosSortOrder = (controlNumber: number, sortedPhotoIds: string[], mountedRef: { current: boolean }, successCallback?: () => void, errorCallback?: () => void) => WebApiRequest({
  method: HTTP_POST,
  endpoint: api.savePhotosSortOrder(controlNumber),
  payload: sortedPhotoIds,
  successCallback,
  errorCallback,
  mountedRef, 
});

export const getCasePhotos = (customerNumber: string, controlNumber: number, ssoToken: string, successCallback: (photos: PhotoPropertiesPhotoSvc[]) => void, errorCallback?: () => void) => {
  fetch(`${WebConfig.photoServiceRoot}/${customerNumber}/${controlNumber}?SSO=${ssoToken}`, {cache: "no-store",})
  .then(response => {
    if (!response.ok)
      errorCallback();
    return response.json();
  })
  .then(response => {
    successCallback(response);
  });
};

export const getCaseDeletedPhotos = (customerNumber: string, controlNumber: number, ssoToken: string, successCallback: (photos: PhotoPropertiesPhotoSvc[]) => void, errorCallback: () => void) => {
  fetch(`${WebConfig.photoServiceRootDelete}/${customerNumber}/${controlNumber}?SSO=${ssoToken}`, {cache: "no-store",})
  .then(response => {
    if (!response.ok)
      errorCallback();
    return response.json();
  })
  .then(response => {
    successCallback(response);
  });
};

export const downloadCasePhotos = (customerNumber: string, controlNumber: number, namingConvention: string, ssoToken: string, successCallback: (blob: Blob) => void) => {
  fetch(`${WebConfig.photoServiceRoot}/${customerNumber}/${controlNumber}/zip?namingconvention=${namingConvention}&SSO=${ssoToken}`, {
    method: "GET",
  })
    .then(response => response.blob())
    .then(blob => successCallback(blob));
};

export const updatePhotoProperties = (customerNumber: string, controlNumber: number, photoId: string, ssoToken: string, body: PhotoPropertiesPhotoSvc, isDeleting: boolean, successCallback: (newPhotoProperties: PhotoPropertiesPhotoSvc) => void, errorCallback: () => void) => {
  const headers = {
    "Content-Type": "application/json; charset=UTF-8",
  };

  fetch(`${isDeleting ? WebConfig.photoServiceRootDelete : WebConfig.photoServiceRoot}/${customerNumber}/${controlNumber}/${photoId}?SSO=${ssoToken}`, {
    method: "PUT",
    body: JSON.stringify(body),
    headers: headers,
  })
  .then(response => {
    if (!response.ok) {
      errorCallback();
    }
    else {
      response.json().then(newPhotoProperties => {
        successCallback(newPhotoProperties);
      });
    }
  });
};

export const updateMultiplePhotoProperties = (customerNumber: string, controlNumber: number, ssoToken: string, isDeleting: boolean, body: UpdateMultiplePhotosRequestBody, successCallback?: (newPhotoProperties: PhotoPropertiesPhotoSvc[]) => void, errorCallback?: () => void) => {
  const headers = {
    "Content-Type": "application/json; charset=UTF-8",
  };
  fetch(`${isDeleting ? WebConfig.photoServiceRootDelete : WebConfig.photoServiceRoot}/${customerNumber}/${controlNumber}?SSO=${ssoToken}`, {
    method: "PUT",
    body: JSON.stringify(body),
    headers: headers,
  })
  .then(response => {
    if (!response.ok) {
      errorCallback();
    }
    else {
      response.json().then(newPhotoProperties => {
        successCallback(newPhotoProperties);
      });
    }
  });
};

export const savePhotoEdit = (customerNumber: string, controlNumber: number, photoId: string, ssoToken: string, body: PhotoEditSaveRequest, successCallback: (newPhotoProperties: PhotoPropertiesPhotoSvc) => void, errorCallback: () => void) => {
  const headers = {
    "Content-Type": "application/json; charset=UTF-8",
  };
  fetch(`${WebConfig.photoServiceRoot}/${customerNumber}/${controlNumber}/${photoId}/edits?SSO=${ssoToken}`, {
    method: "PUT",
    body: JSON.stringify(body),
    headers: headers,
  })
  .then(response => {
    if (!response.ok) {
      errorCallback();
    }
    else {
      response.json().then(newPhotoProperties => {
        successCallback(newPhotoProperties);
      });
    }
  });
};

export const restorePhotoFromTrash = (customerNumber: string, controlNumber: number, ssoToken: string, body: UpdateMultiplePhotosRequestBody, successCallback: (newPhotoPropertiesArray: PhotoPropertiesPhotoSvc[]) => void, errorCallback: () => void) => {
  const headers = {
    "Content-Type": "application/json; charset=UTF-8",
  };

  fetch(`${WebConfig.photoServiceRoot}/${customerNumber}/${controlNumber}?SSO=${ssoToken}`, {
    method: "PUT",
    body: JSON.stringify(body),
    headers: headers,
  })
  .then(response => {
    if (!response.ok) {
      errorCallback();
    }
    else {
      response.json().then(newPhotoPropertiesArray => {
        successCallback(newPhotoPropertiesArray);
      });
    }
  });
};